// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"300":"booknow","498":"bookonline","711":"termsandconditions","739":"privacypolicy","755":"refundpolicy","862":"booking","999":"bookingdetails"}[chunkId] + "." + {"300":"768d638b","498":"d867264c","711":"007483b7","739":"bc935202","755":"50a3d521","862":"4cea6664","999":"41e9b4a6"}[chunkId] + ".js";
};